var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable } from 'mobx';
import API from '../util/ApiUtil';
import { parseParams } from '../util/ParamsUtil';
import { getCurrentLanguage, Language, setLanguage } from '@teliaee/crm-components';
export const languageSlug = (lang) => {
    return !lang || lang === DEFAULT_LANGUAGE ? '' : `/${lang}`;
};
export const ALLOWED_LANGUAGES = [Language.ET, Language.RU];
export const DEFAULT_LANGUAGE = Language.ET;
class TranslateStore {
    constructor() {
        Object.defineProperty(this, "translations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "currentLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultTranslateAppName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'diilcrm'
        });
        Object.defineProperty(this, "globalDiilTranslateAppName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'globaldiil'
        });
        Object.defineProperty(this, "setLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (language) => {
                if (this.currentLanguage !== language && ALLOWED_LANGUAGES.includes(language)) {
                    this.setCurrentLanguage(language);
                    setLanguage(language);
                    this.getTranslations(language);
                }
            }
        });
        Object.defineProperty(this, "setCurrentLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lang) => {
                this.currentLanguage = lang;
            }
        });
        Object.defineProperty(this, "setTranslations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (translations) => {
                this.translations = translations || {};
            }
        });
        Object.defineProperty(this, "translate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, paramObject) => this.getTranslationForGroup(this.defaultTranslateAppName, key, paramObject)
        });
        Object.defineProperty(this, "translateDiilGlobal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, paramObject) => this.getTranslationForGroup(this.globalDiilTranslateAppName, key, paramObject)
        });
        Object.defineProperty(this, "getTranslationForGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (group, key, paramObject) => {
                const groupTranslations = this.translations[group];
                let textValue;
                if (groupTranslations) {
                    textValue = groupTranslations[key];
                }
                if (textValue) {
                    if (paramObject) {
                        return parseParams(textValue, paramObject);
                    }
                    return textValue;
                }
                return `${group}:${key}`;
            }
        });
        makeObservable(this);
        this.setCurrentLanguage(getCurrentLanguage());
        this.getTranslations(this.currentLanguage);
    }
    async getTranslations(lang) {
        await API.get(`/translations/${lang}`, { cancelToken: null })
            .then((response) => {
            this.setTranslations(response.data.translations);
        })
            .catch((e) => {
            console.error(e);
        });
    }
    get diilGlobalTranslations() {
        return this.translations[this.globalDiilTranslateAppName];
    }
}
__decorate([
    observable
], TranslateStore.prototype, "translations", void 0);
__decorate([
    observable
], TranslateStore.prototype, "currentLanguage", void 0);
__decorate([
    action.bound
], TranslateStore.prototype, "setLanguage", void 0);
__decorate([
    action.bound
], TranslateStore.prototype, "setCurrentLanguage", void 0);
__decorate([
    action.bound
], TranslateStore.prototype, "setTranslations", void 0);
__decorate([
    computed
], TranslateStore.prototype, "diilGlobalTranslations", null);
export default TranslateStore;
